import { container } from "assets/jss/material-kit-pro-react.js";

const carouselStyle = {
	section: {
		paddingTop: "70px",
	},
	container,
	marginAuto: {
		marginLeft: "auto !important",
		marginRight: "auto !important",
	},
	slide: {
		height: "463px",
		overflow: "hidden",
		width: "100%",
		position: "relative",
		boxShadow: "0 1px 20px 0 rgba(0, 0, 0, 0.2) !important",
		transition: "all 0.5s ease-in-out",
		"&:hover": {
			boxShadow: "0 1px 20px rgba(0, 0, 0, 0.9)",
		},
	},
	carouselCard: {
		overflow: "hidden",

		padding: "0",
		marginTop: "1.49rem",
		marginBottom: "2.5rem",
		backgroundColor: "transparent",
	},
	slideImage: {
		width: "100%",
		height: "100%",
		objectFit: "cover",
		position: "absolute",
		top: "0",
		left: "0",
		zIndex: "1",
		transition: "all 0.5s ease-in-out",
	},
};

export default carouselStyle;
